import { Block, cloneBlock, Blocks } from 'factories/block';
import { createBlock } from './block';
import { flatten } from 'factories/utils';

export const createAdvancedEditing = (): Block => {
  return createBlock('AdvancedEditing', [], {
    props: {},
  });
};

export const addAdvancedEditingBlock = (block: Block): [Block, Blocks?] => {
  if (block.type === 'Module') {
    const advancedEditingBlock = createAdvancedEditing();

    const advancedEditingBlockRef = {
      id: advancedEditingBlock.id,
      type: 'Ref',
    };

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).push(advancedEditingBlockRef);

    const [newBlocks] = flatten(advancedEditingBlock);

    return [nextBlock, newBlocks];
  }

  return [block, undefined];
};
